import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {

  override parse(value: any): Date | null {
    // Handle string input with "-"
    if (typeof value === 'string' && value.includes('-')) {
      const parts = value.split('-');
      const day = Number(parts[0]);
      const month = Number(parts[1]) - 1; // months are 0-indexed
      const year = Number(parts[2]);
      return new Date(year, month, day);
    }
    return super.parse(value);
  }

  override format(date: Date, displayFormat: Object): string {
    const day = this._to2digit(date.getDate());
    const month = this._to2digit(date.getMonth() + 1);
    const year = date.getFullYear();
    return `${day}-${month}-${year}`; // format with dashes
  }

  private _to2digit(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }
}
